<div class="header lt">
  <mat-icon class="add-email-icon" svgIcon="add_email"></mat-icon>
  <div class="content">
      <h1 mat-dialog-title class="title" color="danger">{{ reference.title | translate }}</h1>
      <span class="desc">{{ reference.msg | translate}}</span>
  </div>
</div>
<!-- <mat-dialog-content>
  <form [formGroup]="form" class="flex-col lt add-email mt-5">
      <label for="email" class="label-controls accent">{{ 'LABEL.EMAIL' | translate }}</label>
      <mat-form-field color="accent" appearance="outline" class="form">
          <input type="email" formControlName="email" matInput [placeholder]="'LABEL.EMAIL' | translate" id="email">
          <mat-icon matPrefix>email</mat-icon>
      </mat-form-field>
      <mat-error @fade *ngIf="form.get('email').invalid && form.get('email').touched && !form.get('email').hasError('email')">{{'MSG.EMAIL_REQUIRED' | translate}}</mat-error>
      <mat-error @fade *ngIf="form.get('email').hasError('email')">
          {{ 'MSG.VALID_EMAIL_REQUIRED' | translate }}
      </mat-error>
  </form>
</mat-dialog-content> -->
<mat-dialog-actions align="end">
      <button class="mat-custom-btn btn-color" mat-flat-button  [mat-dialog-close]="true">{{ 'LABEL.CLOSE' | translate }}</button>
</mat-dialog-actions>